import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { PersistenceGateService } from './shared/services/persistence-gate.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, GridModule],
  changeDetection: ChangeDetectionStrategy.Default,
  template: ` <router-outlet></router-outlet> `,
})
export class App {
  private persistenceGate = inject(PersistenceGateService);

  constructor() {
    this.persistenceGate.clearRetiredWidgetCache();
  }
}
